import React, { useEffect, useRef } from 'react';
import { SECTION_IDS } from '../../constants/routes';
import './SuccessCard.css';

const SuccessCard = ({ tournament, onDismiss }) => {
    const closeButtonRef = useRef(null);

    useEffect(() => {
        closeButtonRef.current?.focus();
    }, []);

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            onDismiss();
        }
    };

    const readableDate = tournament?.startDateTime
        ? new Date(tournament.startDateTime).toLocaleString('de-DE', {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        })
        : tournament?.date || 'Unbekanntes Datum';

    return (
        <div
            className="success-card"
            data-testid="registration-success-card"
            role="dialog"
            aria-label="Anmeldung erfolgreich"
            onKeyDown={handleKeyDown}
        >
            <div className="success-card__header">
                <button
                    ref={closeButtonRef}
                    className="success-card__close"
                    onClick={onDismiss}
                    aria-label="Schließen"
                    data-testid="registration-success-close"
                    type="button"
                >
                    &times;
                </button>
            </div>
            <div className="success-card__body">
                <div className="success-card__checkmark" aria-hidden="true" data-testid="registration-success-checkmark">
                    <svg
                        className="success-card__checkmark-svg"
                        viewBox="0 0 52 52"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            className="success-card__checkmark-circle"
                            cx="26"
                            cy="26"
                            r="25"
                            fill="none"
                        />
                        <path
                            className="success-card__checkmark-check"
                            fill="none"
                            d="M14 27l7 7 16-16"
                        />
                    </svg>
                </div>
                <p className="success-card__message" data-testid="registration-success-message">
                    Du bist f&uuml;r {readableDate} &ndash; {tournament?.title || 'dieses Turnier'} angemeldet.
                </p>
                <a
                    className="success-card__link"
                    href={`/#${SECTION_IDS.KICK_CALENDAR}`}
                    data-testid="registration-success-calendar-link"
                >
                    Zum Kalender
                </a>
            </div>
        </div>
    );
};

export default SuccessCard;
